/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - EMOJI SELECTION: STYLES --------------- ++++++++++ */
export default theme => ({
  emoji: {
    '&.type-monochrome, &.type-skeleton': {
     '&.isDark-true': {
      '& *[fill]:not(svg)': {
        fill: '#FFFFFF',
        stroke: '#FFFFFF',
        strokeWidth: '0.5px'
      }
     }
    }
  }
});
